var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.03 22.83"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 21.41l10.53-9.79L10.05 1.41M19.72 11.66H1"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4wMyAyMi44MyI+CiAgPHBvbHlsaW5lIHBvaW50cz0iMTAuMDUgMjEuNDEgMjAuNTggMTEuNjIgMTAuMDUgMS40MSIgLz4KICA8cGF0aCBkPSJNMTkuNzIsMTEuNjZIMSIgLz4KPC9zdmc+Cg==";
export { SvgArrow as ReactComponent };